"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Localize_1 = require("./../../gen-src/Localize");
var Icons_1 = require("../Icons");
var NestedProjectsFractalRowStore_1 = require("../NestedProjectsFractalRowStore");
var ConditionallyDisabledCell_1 = require("./ConditionallyDisabledCell");
var PlainTextCellWithIcon_1 = require("./PlainTextCellWithIcon");
/**
 * Wraps the Nested Project Explorer cell in a ConditionallyDisabledCell, which grays out
 * projects that are not valid destinations for the source item.
 */
function getDestinationProjectCellFormatter() {
    function buildCellMetadata(rowData) {
        var title = messageForDestinationStatus(rowData);
        if (rowData.id === NestedProjectsFractalRowStore_1.NestedProjectsFractalRowStore.SentinelSiteId) {
            return {
                text: Localize_1.Messages.moveToProject_siteRootDestination({ SITE_NAME: rowData.name }),
                title: title,
                iconDataUri: Icons_1.Icons.SiteContentTypeSmall,
            };
        }
        else {
            return {
                text: rowData.name,
                title: title,
                iconDataUri: Icons_1.Icons.ProjectContentTypeSmall,
            };
        }
    }
    function messageForDestinationStatus(projectInfo) {
        var messageParams = { PROJECT_NAME: projectInfo.name };
        if (projectInfo.status === 'structurally_invalid') {
            return Localize_1.Messages.invalidContentDestination(messageParams);
        }
        else if (projectInfo.status === 'insufficient_permissions') {
            return Localize_1.Messages.insufficientPermissionToMoveTo(messageParams);
        }
        return Localize_1.Messages.validProject(messageParams);
    }
    return ConditionallyDisabledCell_1.ConditionallyDisabledCellComponent(PlainTextCellWithIcon_1.PlainTextCellWithIconComponent(buildCellMetadata), function (rowData) { return rowData.status !== 'valid'; });
}
exports.getDestinationProjectCellFormatter = getDestinationProjectCellFormatter;
//# sourceMappingURL=NestedProjectExplorerCell.js.map